import defaultApi from './defaultApi';

const authApi = {
  auth: {
    prefix: process.env.VUE_APP_PROXY + process.env.VUE_APP_PUBLIC_PATH + '/cloudmonitorings',
    SWAGGER: '/v2/api-docs?group=API-v1.0.0',
    API_INFO: {},
    SAMPLE: {},

    checkProductResource(
      productTypeCode,
      actionName,
      productResourceIds,
      needHandleAuthorizationCheck = false
    ) {
      return new Promise((resolve, reject) => {
        let params = {};
        Object.assign(params, { actionName, productResourceIds });

        this.post(
          '/product/v1/console/products/check-authorization',
          params,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          needHandleAuthorizationCheck
        )
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    }
  }
};

authApi.auth = Object.assign(authApi.auth, defaultApi);

export default authApi;
